import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Logo } from "@/components/brand/Logo";

export default function SignupPage() {
  const nav = useNavigate();
  const { register, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [full_name, setName] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => { if (user) nav(user.role === "admin" ? "/admin" : "/portal"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    const res = await register({ email, password, full_name, phone });
    if (!res.ok) toast.error(res.error);
    else toast.success("Welcome to AlfaDrive!");
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-background flex items-center" data-testid="signup-page">
      <div className="container-x grid lg:grid-cols-2 gap-10 items-center py-10">
        <div className="hidden lg:block">
          <div className="card-clean hero-wash p-10 relative overflow-hidden min-h-[560px]">
            <Logo variant="lockup" height={48} to={null} />
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-border bg-white px-3 py-1 text-xs text-muted-foreground">Create your account</div>
            <h1 className="mt-4 font-display text-4xl font-semibold leading-tight">A smarter way to <br /><span className="text-[hsl(var(--primary))]">access mobility.</span></h1>
            <p className="mt-4 text-muted-foreground max-w-md">Reserve vehicles, join Drive Alfa Club for member pricing, and access flexible longer-term plans — all in one place. <span className="text-[hsl(var(--danger))] font-medium">Dare to Live.</span></p>
          </div>
        </div>
        <div className="max-w-md w-full mx-auto lg:mx-0">
          <h2 className="font-display text-3xl font-semibold">Create your account</h2>
          <p className="text-muted-foreground mt-1">Takes under a minute.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label htmlFor="name">Full name</Label><Input id="name" required value={full_name} onChange={(e) => setName(e.target.value)} placeholder="Alex Morgan" data-testid="signup-name" /></div>
            <div><Label htmlFor="phone">Phone number</Label><Input id="phone" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+1 (416) 555-0000" data-testid="signup-phone" /></div>
            <div><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="signup-email" /></div>
            <div><Label htmlFor="password">Password</Label><Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" data-testid="signup-password" /></div>
            <Button type="submit" className="w-full h-11 rounded-xl bg-[hsl(var(--primary))] hover:bg-[hsl(var(--blue-500))]" disabled={loading} data-testid="signup-submit-button">
              {loading ? "Creating…" : "Create account"}
            </Button>
            <p className="text-sm text-muted-foreground text-center">Already have an account? <Link to="/login" className="underline underline-offset-4">Sign in</Link></p>
          </form>
        </div>
      </div>
    </div>
  );
}
